import React from 'react';
import { Link } from "react-router-dom";
import img1 from '../../Assets/Images/img1.png';
import img2 from '../../Assets/Images/img2.png';
import img3 from '../../Assets/Images/img3.png';
import img4 from '../../Assets/Images/img4.png';
import './mainmenu.css';

const Mainmenu =()=>{
    return(
        <div className="container">
            <div className="row mb-2">
                <div className="col-xl-3 col-md-3 col-xs-12">
                <Link className="linko" to="/foodiary">
                    <div className="box">
                        <div className="square">
                            <img className="imma" src={img1} alt=""/>
                            <h6 className="title">DIARIO ALIMENTARE</h6>
                        </div>
                    </div>
                </Link>
                </div>
                <div className="col-xl-3 col-md-3 col-xs-12">
                <Link className="linko" to="/wodiary">
                    <div className="box">
                        <div className="square">
                            <img className="imma" src={img2} alt=""/>
                            <h6 className="title">DIARIO ALLENAMENTO</h6>
                        </div>
                    </div>
                </Link>
                </div>
                <div className="col-xl-3 col-md-3 col-xs-12">
                <Link className="linko" to="/exelibrary">
                    <div className="box">
                        <div className="square">
                            <img className="imma" src={img3} alt=""/>
                            <h6 className="title">DIARIO ESERCIZI</h6>
                        </div>
                    </div>
                </Link>
                </div>
                <div className="col-xl-3 col-md-3 col-xs-12">
                <Link className="linko" to="/goalslib">
                    <div className="box">
                        <div className="square">
                            <img className="imma" src={img4} alt=""/>
                            <h6 className="title">OBIETTIVI</h6>
                        </div>
                    </div>
                </Link>
                </div>
            </div>

        </div>
    )
}
export default Mainmenu;